import React from 'react';

function SocialMedia() {
  return (
    <section style={{background: 'linear-gradient(135deg, #fdf4ff 0%, #fae8ff 100%)', minHeight: '100vh', padding: '160px 0 80px 0'}}>
      <div className="container">
        <div style={{textAlign: 'center', marginBottom: '60px'}}>
          <h2 style={{fontSize: '4rem', color: '#581c87', fontWeight: 900, marginBottom: '20px'}}>Connect With Us</h2>
          <p style={{fontSize: '1.4rem', color: '#7e22ce', maxWidth: '800px', margin: '0 auto'}}>Follow us on social media to stay updated with school activities, events, and achievements</p>
        </div>

        {/* Social Media Cards with Embedded Content */}
        <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px', marginBottom: '60px', maxWidth: '1200px', margin: '0 auto 60px'}}>
          {/* YouTube */}
          <div style={{background: 'white', padding: '40px', borderRadius: '25px', boxShadow: '0 15px 40px rgba(0,0,0,0.1)', transition: 'transform 0.3s'}}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
            <div style={{background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)', width: '100px', height: '100px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 25px', boxShadow: '0 10px 30px rgba(255, 0, 0, 0.3)', transition: 'transform 0.3s', cursor: 'pointer'}}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.4)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              <i className="fab fa-youtube" style={{fontSize: '3.5rem', color: 'white'}}></i>
            </div>
            <h3 style={{fontSize: '2rem', color: '#1e293b', marginBottom: '15px', fontWeight: 800, textAlign: 'center'}}>YouTube</h3>
            <p style={{fontSize: '1.05rem', color: '#64748b', lineHeight: 1.7, marginBottom: '25px', textAlign: 'center'}}>
              Watch our school events, celebrations, and educational content
            </p>
            <div style={{textAlign: 'center', marginBottom: '25px'}}>
              <a
                href="https://www.youtube.com/@bethelonline7627"
                target="_blank"
                rel="noopener noreferrer"
                style={{background: 'linear-gradient(135deg, #ff0000 0%, #cc0000 100%)', color: 'white', padding: '15px 40px', borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '1.1rem', display: 'inline-block', boxShadow: '0 8px 20px rgba(255, 0, 0, 0.3)', transition: 'all 0.3s'}}
                onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
              >
                <i className="fab fa-youtube" style={{marginRight: '10px'}}></i>Subscribe Now
              </a>
            </div>
          </div>

          {/* Facebook */}
          <div style={{background: 'white', padding: '40px', borderRadius: '25px', boxShadow: '0 15px 40px rgba(0,0,0,0.1)', transition: 'transform 0.3s'}}
            onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-10px)'}
            onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
            <div style={{background: 'linear-gradient(135deg, #1877f2 0%, #0c63d4 100%)', width: '100px', height: '100px', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 25px', boxShadow: '0 10px 30px rgba(24, 119, 242, 0.3)', transition: 'transform 0.3s', cursor: 'pointer'}}
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.4)'}
              onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}>
              <i className="fab fa-facebook-f" style={{fontSize: '3.5rem', color: 'white'}}></i>
            </div>
            <h3 style={{fontSize: '2rem', color: '#1e293b', marginBottom: '15px', fontWeight: 800, textAlign: 'center'}}>Facebook</h3>
            <p style={{fontSize: '1.05rem', color: '#64748b', lineHeight: 1.7, marginBottom: '25px', textAlign: 'center'}}>
              Stay connected with daily updates and interact with our community
            </p>
            <div style={{textAlign: 'center', marginBottom: '25px'}}>
              <a
                href="https://www.facebook.com/BethelPublicSchool/"
                target="_blank"
                rel="noopener noreferrer"
                style={{background: 'linear-gradient(135deg, #1877f2 0%, #0c63d4 100%)', color: 'white', padding: '15px 40px', borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '1.1rem', display: 'inline-block', boxShadow: '0 8px 20px rgba(24, 119, 242, 0.3)', transition: 'all 0.3s'}}
                onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
                onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
              >
                <i className="fab fa-facebook-f" style={{marginRight: '10px'}}></i>Follow Us
              </a>
            </div>
          </div>
        </div>

        {/* Featured Video */}
        <div style={{marginBottom: '60px', background: 'white', padding: '40px', borderRadius: '25px', boxShadow: '0 15px 40px rgba(0,0,0,0.1)'}}>
          <h3 style={{fontSize: '2.5rem', color: '#581c87', marginBottom: '30px', fontWeight: 800, textAlign: 'center'}}>Featured Video</h3>
          <div style={{position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden', borderRadius: '15px', boxShadow: '0 10px 30px rgba(0,0,0,0.2)'}}>
            <iframe
              style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0}}
              src="https://www.youtube.com/embed/I4-K6Xn_NJc"
              title="Annual Day 2023-24 Dance By 5th&6th Girls"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
          <h4 style={{fontSize: '1.5rem', color: '#1e293b', marginTop: '20px', fontWeight: 700, textAlign: 'center'}}>Annual Day 2023-24 Dance By 5th & 6th Girls</h4>
        </div>

        {/* Latest Videos */}
        <div style={{marginBottom: '60px'}}>
          <h3 style={{fontSize: '2.5rem', color: '#581c87', marginBottom: '40px', fontWeight: 800, textAlign: 'center'}}>More Videos from Our Channel</h3>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(380px, 1fr))', gap: '30px'}}>
            {[
              {id: 'GhQP1_cIvps', title: 'Annual Day 2023-24 Dance by LKG Kids'},
              {id: 'XDtnmHxrpyE', title: 'Annual Day 2023-24 Dance By Class 10 Boys'},
              {id: 'Dc8vAhnTBA4', title: 'Class 10 Girls Dance with Deepam'}
            ].map((video, i) => (
              <div key={i} style={{background: 'white', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)', transition: 'transform 0.3s'}}
                onMouseEnter={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
                <div style={{position: 'relative', paddingBottom: '56.25%', height: 0, overflow: 'hidden'}}>
                  <iframe
                    style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 0}}
                    src={`https://www.youtube.com/embed/${video.id}`}
                    title={video.title}
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  ></iframe>
                </div>
                <div style={{padding: '20px'}}>
                  <h4 style={{fontSize: '1.2rem', color: '#1e293b', fontWeight: 700}}>{video.title}</h4>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Call to Action */}
        <div style={{background: 'linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)', padding: '50px', borderRadius: '25px', textAlign: 'center', color: 'white', boxShadow: '0 15px 40px rgba(124, 58, 237, 0.3)'}}>
          <i className="fas fa-share-alt" style={{fontSize: '3.5rem', marginBottom: '20px'}}></i>
          <h3 style={{fontSize: '2.2rem', marginBottom: '20px', fontWeight: 800}}>Join Our Online Community</h3>
          <p style={{fontSize: '1.2rem', marginBottom: '30px', opacity: 0.95, maxWidth: '800px', margin: '0 auto 30px'}}>
            Be part of our growing online family. Share your experiences, stay updated with school news, and never miss an important announcement. Follow us today!
          </p>
          <div style={{display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap'}}>
            <a
              href="https://www.youtube.com/@bethelonline7627"
              target="_blank"
              rel="noopener noreferrer"
              style={{background: '#ff0000', color: 'white', padding: '15px 35px', borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '1.1rem', display: 'inline-block', boxShadow: '0 8px 20px rgba(255, 0, 0, 0.4)', transition: 'all 0.3s'}}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <i className="fab fa-youtube" style={{marginRight: '10px'}}></i>YouTube
            </a>
            <a
              href="https://www.facebook.com/BethelPublicSchool/"
              target="_blank"
              rel="noopener noreferrer"
              style={{background: '#1877f2', color: 'white', padding: '15px 35px', borderRadius: '50px', textDecoration: 'none', fontWeight: 700, fontSize: '1.1rem', display: 'inline-block', boxShadow: '0 8px 20px rgba(24, 119, 242, 0.4)', transition: 'all 0.3s'}}
              onMouseEnter={(e) => e.target.style.transform = 'translateY(-3px)'}
              onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
            >
              <i className="fab fa-facebook-f" style={{marginRight: '10px'}}></i>Facebook
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialMedia;
